import type { OrganizationFrame, OrganizationUser } from "@kontextwerk/control-web-client"
import type { RecordDetailHeaderPresentation } from "@kontextwerk/web-sdk/ui/layout/recordDetail/types"
import { mdiAccountOutline } from "@mdi/js"

export const userRecordIcon = mdiAccountOutline

export const buildUserHeader = (
  user: OrganizationUser,
  organization: Pick<OrganizationFrame, "name"> | null,
): RecordDetailHeaderPresentation => {
  const fields: RecordDetailHeaderPresentation["fields"] = []
  const email = user.email?.trim()
  const role = {
    admin: "Admin",
    customer_admin: "Organisations-Admin",
    customer: "Benutzer",
  }[user.role]
  const organizationName = organization?.name?.trim()

  if (email) fields.push({ id: "email", label: "E-Mail", value: email })

  if (role) fields.push({ id: "role", label: "Rolle", value: role })

  if (organizationName) {
    fields.push({ id: "organization", label: "Organisation", value: organizationName })
  }

  return { icon: userRecordIcon, fields }
}
